import React, { useState } from "react";
import "./RelatedProducts.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import { Navigation } from "swiper/modules";

import StoreData from "../../../Data/StoreData";

import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import Spinner from "../../Spinner";

import { FiHeart } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";

const RelatedProducts = () => {
  const [wishList, setWishList] = useState({});
  const [products, setProducts] = React.useState([]);
  const [paginationMessage, setPaginationMessage] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [spinner, setSpinner] = React.useState(false);

  const getAllProducts = (offset, limit) => {
    setSpinner(true);
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/products/getAllProducts`,
      data: {
        filters: [],
        offset: offset,
        limit: limit
      },
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        setProducts(res.data?.data);
      } else {
        setError('Došlo je do serverske greške');
      }
    }).catch(() => {
      setError('Došlo je do serverske greške');
    }).finally(() => {
      setSpinner(false);
    });
  }

  const handleWishlistClick = (productID) => {
    setWishList((prevWishlist) => ({
      ...prevWishlist,
      [productID]: !prevWishlist[productID],
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  React.useEffect(() => {
    getAllProducts(0, 16);
  }, []);

  return (
    <>
      <div className="relatedProductSection">
        <div className="relatedProducts">
          <h2>
            POGLEDAJ <span>JOŠ MODELA</span>
          </h2>
        </div>
        <div className="relatedProductSlider">
          <div className="swiper-button image-swiper-button-next">
            <IoIosArrowForward />
          </div>
          <div className="swiper-button image-swiper-button-prev">
            <IoIosArrowBack />
          </div>
          <Swiper
            slidesPerView={4}
            slidesPerGroup={4}
            spaceBetween={30}
            loop={true}
            navigation={{
              nextEl: ".image-swiper-button-next",
              prevEl: ".image-swiper-button-prev",
            }}
            modules={[Navigation]}
            breakpoints={{
              320: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 14,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 30,
              },
            }}
          >
            {products.map((product) => {
              return (
                <SwiperSlide key={product.productID}>
                  <div className="rpContainer">
                    <div className="rpImages" onClick={scrollToTop}>
                      <Link to={`/Product?id=${product.ID}`} onClick={() => { setTimeout(() => { window.location.reload() }, 100) }}>

                        <img
                          src={`${backendModule.backendURL}/${product.ImagePath}`}
                          alt={product.Name}
                          className="rpFrontImg"
                        />
                        <img
                          src={`${backendModule.backendURL}/${product.ImagePath2}`}
                          className="rpBackImg"
                          alt={product.Name}
                        />
                      </Link>
                    </div>

                    <div className="relatedProductInfo">
                      <br />
                      <Link to={`/Product?id=${product.ID}`} onClick={() => { setTimeout(() => { window.location.reload() }, 100) }}>
                        <div className="productNameInfo">
                          <h5 onClick={scrollToTop}>{product.Name}</h5>
                          <p>{product.Price} KM</p>
                          <div className="productRatingReviews">
                            <div className="productRatingStar">
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                            </div>

                            <span>100+ ocjena</span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default RelatedProducts;
